module.exports = __webpack_public_path__ + "img/service_icon6.71c99c0b.png";